export default {
  meta: {
    title: '小区围栏页',
  },
};
